/* --- Color swatch OOS re-evaluation per selected size (sheets-revamp PDP) --- */
// theme.js's setAvailability() marks a color .variant-oos if ANY size of that
// color is sold out, and never clears it when the selected size changes. Re-stamp
// the class so a swatch only strikes through when (selected size + that color) is
// actually unavailable. Ported from the unified-buybox PDP, which carries the same fix.

document
  .querySelectorAll('.sheets-revamp[data-section-type="product"]')
  .forEach((section) => {
    const jsonEl = section.querySelector('textarea[data-variant-json]');

    if (!jsonEl) return;

    let variants;

    try {
      variants = JSON.parse(jsonEl.value);
    } catch (e) {
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    const variantControl = section.querySelector(
      '.product-block--variant-selector'
    );

    if (!variantControl) return;

    const fieldsets = Array.from(
      variantControl.querySelectorAll('fieldset[data-index]')
    );

    if (fieldsets.length < 2) return;

    const colorFieldset = fieldsets.find((fs) =>
      fs.querySelector('input.variant__input--color-swatch')
    );

    if (!colorFieldset) return;

    const colorKey = colorFieldset.dataset.index;
    const otherFieldsets = fieldsets.filter((fs) => fs !== colorFieldset);

    const reevaluate = () => {
      const selectedOther = {};

      otherFieldsets.forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');

        if (checked) selectedOther[fs.dataset.index] = checked.value;
      });

      const colorInputs = colorFieldset.querySelectorAll(
        'input.variant__input--color-swatch'
      );

      colorInputs.forEach((input) => {
        const label = input.parentElement.querySelector('label.color-swatch');

        if (!label) return;

        const match = variants.find((v) => {
          if (v[colorKey] !== input.value) return false;

          return Object.keys(selectedOther).every(
            (k) => v[k] === selectedOther[k]
          );
        });

        const shouldStrike = !match || match.available === false;

        label.classList.toggle('variant-oos', shouldStrike);
      });
    };

    document.addEventListener('variant:change', (e) => {
      const originalTarget =
        e.detail && e.detail.originalEvent && e.detail.originalEvent.target;

      if (!originalTarget || !section.contains(originalTarget)) return;

      reevaluate();
    });

    const runInitial = () => setTimeout(reevaluate, 0);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitial, { once: true });
    } else {
      runInitial();
    }

    window.addEventListener('load', reevaluate, { once: true });
  });
